<script>
import forminput from "@/router/views/FormComponet/forminput.vue";
import formcheckbox from "@/router/views/FormComponet/formcheckbox.vue";
import formckeditor from "@/router/views/FormComponet/formckeditor.vue";
import formdate from "@/router/views/FormComponet/formdate.vue";
import Treeselect from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css"; 
import Loader from "@/components/widgets/loader";
import Api from "@/helpers/apibtoast";
import Sabit from "@/helpers/apigeneric";
import AnktAnket from "@/models/AnktAnket";
import moment from "moment";
export default {
  mixins: [Api, Sabit, AnktAnket],
  props: ["Id", "AddEdit"],
  data() {
    return {
      FormData: {},
      file: "",
      uzanti: "",
      KullaniciRolleri: null, 
    };
  },
  components: {
    Loader,
    forminput, 
    formcheckbox,
    formckeditor,
    formdate,
    Treeselect
  },
  watch: {
    Id() {
      this.FormData = this.Id;
      if(this.AddEdit == "Add"){
        this.FormData.Yetkilipersonelids.push(this.TokenUserId);
      }
    },
  },
  created(){
    
  },
  methods: {
    onSubmit() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        
        if (!this.FormData.Bitistarihi) {
          this.$delete(this.FormData, "Bitistarihi");
        }
 
        if (this.file.name) { 
       if (this.uzanti=='png' || this.uzanti=='jpeg' || this.uzanti=='jpg' ) {

                  let formData = new FormData();
                  formData.append("file", this.file);
                  this.ActionsPost({
                    Service: "GenericFileUpDownload/UploadFile?pathUrl=Ankt",
                    Data: formData,
                  }).then((res) => { 
                    if (res.Succeeded == true) { 
                      this.FormData.Filename = "ankt/" + res.Data.filename;
                      this.DataPostUpdate();
                    } else {
                      this.$toast.error(this.$t("ToasMessage.FileNegatif"));
                    }
                  });
                   }else{
          this.$toast.error(this.$t("ToasMessage.FileNegatifUzanti"));
        }
        } else {
          this.DataPostUpdate();
        }
      }
    },
    DataPostUpdate() {
      if (this.AddEdit == "Add") {
        this.$delete(this.FormData, "LastModified");
        this.FormData.Created =
          moment(new Date()).format("YYYY-MM-DDTHH:mm:ss") + "Z";
        this.Post("AnktAnket", this.FormData).then((res) => {
          if (res) {
            this.FormData = this.AnktAnketData;
            this.$emit("TableUpdate");
            this.$bvModal.hide("AnktAnket");
          }
        });
      } else {
        this.FormData.LastModified =
          moment(new Date()).format("YYYY-MM-DDTHH:mm:ss") + "Z";
        this.Update("AnktAnket", this.FormData).then((res) => {
          if (res) {
            this.$emit("Update", this.FormData);
            this.FormData = this.AnktAnketData;
            this.$emit("TableUpdate");
            this.$bvModal.hide("AnktAnket");
          }
        });
      }
    },

    Get() {
    
  
    },

    UpdateYetkiliPersonel(Data) {
      let Bellek = [];
      Data.forEach((DataSingle) => {
        Bellek.push(DataSingle.Id);
      });
      this.FormData.Yetkilipersonelids = Bellek;
    },
    UpdateKimlerGorebilir(Data) {
      let Bellek = [];
      Data.forEach((DataSingle) => {
        Bellek.push(DataSingle.Id);
      });
      this.FormData.Kimlergorebilir = Bellek;
    },
    FileUpload() {
      this.file = this.$refs.file.files[0];
      let x = this.file.name;
      //this.FormData.Filename = this.file.name;
      this.uzanti = x.substr(
        x.lastIndexOf(".") + 1,
        x.length - x.lastIndexOf(".")
      ); 
       if ( this.uzanti=='png' || this.uzanti=='jpeg' || this.uzanti=='jpg' ) {
      
      this.uzanti = this.uzanti
      }else{
 this.$toast.error(this.$t("ToasMessage.FileNegatifUzanti"));
      }
    },

    DisuygulamaadiEkle(){
      this.FormData.Disuygulamaadi.push("")
    },
    DisuygulamaadiSil(index){ 
        this.$delete(this.FormData.Disuygulamaadi, index);
    }
    
  },
};
</script>
<template>
  <Loader>
    <!-- no-enforce-focus="false" eklendi modele link olayı çalışmıyordu -->
    <b-modal
      id="AnktAnket"
      no-enforce-focus="false"
      size="lg" 
      :title="
        this.AddEdit == 'Edit'
          ? $t('AnktAnket.AddEdit.FormTitleEdit')
          : $t('AnktAnket.AddEdit.FormTitleAdd')
      "
      title-class="font-18"
      hide-footer
    >
      <Form @submit.prevent="onSubmit">   
        <div class="row">
          <div class="col-md-6">
            <forminput
              :FormDataType="FormDataType.Baslik"
              :Value="FormData.Baslik"
              :v="$v.FormData.Baslik"
              @input="FormData.Baslik = $event"
            />
          </div>
          <div class="col-md-6">
       
            <b-form-group
              id="example text"
              :label="FormDataType.Filename.FieldTitle"
              label-for="text"
            >
              <input
                class="form-control"
                ref="file"
                type="file"
                v-on:change="FileUpload($event)"
                id="FormData.Filename"
                accept=".jpg, .jpeg, .png "
              />
            </b-form-group>
              </div>
              
       
              <div class="row">
              <div class="col-md-6">
                   <forminput
              :FormDataType="FormDataType.BackgroundColor"
              :Value="FormData.BackgroundColor"
              :v="$v.FormData.BackgroundColor"
              @input="FormData.BackgroundColor = $event"
            />
              </div>


                <div class="col-sm-6 mt-2">
            <b-form-group
              :label="FormDataType.Birimid.FieldTitle"
              label-for="text"
            >
       
              <treeselect
                :multiple="false"
                :options="FormDataType.Birimid.ComboDataArray"
                 placeholder="Seçiniz..."
                v-model="FormData.Birimid"
    valueConsistsOf="LEAF_PRIORITY" 
                :class="{ 'is-invalid': $v.FormData.Birimid.$error }"
              /> 
              <div v-if="$v.FormData.Birimid.$error" class="invalid-feedback">
                <span v-if="$v.FormData.Birimid.required == false">{{
                  $t("ValidationMessage.required")
                }}</span>
              </div>
            </b-form-group>
          </div>

           
          </div>
        </div>
        <formckeditor
          :FormDataType="FormDataType.Aciklama"
          :Value="FormData.Aciklama"
          :v="$v.FormData.Aciklama"
          @input="FormData.Aciklama = $event"
        />

        <div class="row">
          <div class="col-sm-6">
            <b-form-group
              :label="FormDataType.Yetkilipersonelids.FieldTitle"
              label-for="text"
            >

             <treeselect
                :multiple="true"
                :options="FormDataType.Yetkilipersonelids.ComboDataArray"
                 placeholder="Seçiniz..."
                v-model="FormData.Yetkilipersonelids"
                :class="{ 'is-invalid': $v.FormData.Yetkilipersonelids.$error }"
              /> 
              <div
                v-if="$v.FormData.Yetkilipersonelids.$error"
                class="invalid-feedback"
              >
                <span v-if="$v.FormData.Yetkilipersonelids.required == false">{{
                  $t("ValidationMessage.required")
                }}</span>
              </div>
            </b-form-group>
          </div>

           
          <div class="col-sm-6  ">
            <b-form-group
              :label="FormDataType.Birimids.FieldTitle"
              label-for="text"
            >
            <treeselect
                :multiple="true"
                :options="FormDataType.Birimids.ComboDataArray"
                 placeholder="Seçiniz..."
                v-model="FormData.Birimids"
    valueConsistsOf="LEAF_PRIORITY" 
                :class="{ 'is-invalid': $v.FormData.Birimids.$error }"
              /> 
              <div v-if="$v.FormData.Birimids.$error" class="invalid-feedback">
                <span v-if="$v.FormData.Birimids.required == false">{{
                  $t("ValidationMessage.required")
                }}</span>
              </div>
            </b-form-group>
          </div>
          

          
          <div class="col-sm-6 mt-2">
            <b-form-group
              :label="FormDataType.Kimlercevaplayabilir.FieldTitle"
              label-for="text"
            >
             <treeselect
                :multiple="true"
                :options="FormDataType.Kimlercevaplayabilir.ComboDataArray"
                 placeholder="Seçiniz..."
                v-model="FormData.Kimlercevaplayabilir"
                :class="{ 'is-invalid': $v.FormData.Kimlercevaplayabilir.$error }"
              /> 

              <div
                v-if="$v.FormData.Kimlercevaplayabilir.$error"
                class="invalid-feedback"
              >
                <span
                  v-if="$v.FormData.Kimlercevaplayabilir.required == false"
                  >{{ $t("ValidationMessage.required") }}</span
                >
              </div>
            </b-form-group>
          </div>
          <div class="col-sm-6 mt-2"> 
            <b-form-group
              :label="FormDataType.Uygulamaids.FieldTitle"
              label-for="text"
            >
            <treeselect
                :multiple="true"
                :options="FormDataType.Uygulamaids.ComboDataArray"
                 placeholder="Seçiniz..."
                v-model="FormData.Uygulamaids"
                :class="{ 'is-invalid': $v.FormData.Uygulamaids.$error }"
                
    valueConsistsOf="LEAF_PRIORITY" 
              /> 
              <div
                v-if="$v.FormData.Uygulamaids.$error"
                class="invalid-feedback"
              >
                <span v-if="$v.FormData.Uygulamaids.required == false">{{
                  $t("ValidationMessage.required")
                }}</span>
              </div>
            </b-form-group>
          
            <div class="row mt-2">  
              <div class="col-md-9">Anket Uygulanacak Dış Uygulamalar</div>
              <div class="col-md-2">
                <i class="mdi mdi-plus me-1"
                @click="DisuygulamaadiEkle()"
                ></i>
              </div>
              <div class="row mt-2" v-for="(Data,index) in FormData.Disuygulamaadi" :key="index">
              <div class="col-md-10"> 
                  <b-form-input 
                 v-model="FormData.Disuygulamaadi[index]"
                  for="text"  
                  ></b-form-input> 
              </div>
              <div class="col-md-2">
                <i class="fas fa-trash-alt"
                @click="DisuygulamaadiSil(index)"
                ></i>
              </div>
            </div> 
            </div> 
          </div>
        
         
          
          </div> 
<div class="row">
          <div class="col-sm-6 mt-2">
            <formdate
              :FormDataType="FormDataType.Baslamatarihi"
              :Value="FormData.Baslamatarihi"
              :v="$v.FormData.Baslamatarihi"
              @input="FormData.Baslamatarihi = $event"
            />
          </div>
          <div class="col-sm-6 mt-2">
            <formdate
              :FormDataType="FormDataType.Bitistarihi"
              :Value="FormData.Bitistarihi"
              :v="$v.FormData.Bitistarihi"
              @input="FormData.Bitistarihi = $event"
            />
          </div>
        </div>
        <br />
        <div class="row">
          <div class="col-sm-3">
            <formcheckbox
              :FormDataType="FormDataType.Yanitlamakistemiyorum"
              :Value="FormData.Yanitlamakistemiyorum"
              :v="$v.FormData.Yanitlamakistemiyorum"
              @input="FormData.Yanitlamakistemiyorum = $event"
            />
          </div>
          <div class="col-sm-3">
            <formcheckbox
              :FormDataType="FormDataType.Ertele"
              :Value="FormData.Ertele"
              :v="$v.FormData.Ertele"
              @input="FormData.Ertele = $event"
            />
          </div>
          <div class="col-sm-3">
            <formcheckbox
              :FormDataType="FormDataType.Ipkontrol"
              :Value="FormData.Ipkontrol"
              :v="$v.FormData.Ipkontrol"
              @input="FormData.Ipkontrol = $event"
            />
          </div>
          <div class="col-sm-3">
            <formcheckbox
              :FormDataType="FormDataType.Testkullanim"
              :Value="FormData.Testkullanim"
              :v="$v.FormData.Testkullanim"
              @input="FormData.Testkullanim = $event"
            />
          </div>
        </div>
        <forminput
          :FormDataType="FormDataType.Disanketurl"
          :Value="FormData.Disanketurl"
          :v="$v.FormData.Disanketurl"
          @input="FormData.Disanketurl = $event"
        />
        <div class="row">
          <div class="col-sm-9">
            <forminput
                      v-if="UserRolles.filter((notification) =>notification.includes('AnketAdmin') || notification.includes('SuperAdmin')|| notification.includes('AnketKullanici')).length != 0 "

              :FormDataType="FormDataType.Anketkapalimesaji"
              :Value="FormData.Anketkapalimesaji"
              :v="$v.FormData.Anketkapalimesaji"
              @input="FormData.Anketkapalimesaji = $event"
            />
          </div>
          <div class="col-sm-3"
          v-if="UserRolles.filter((notification) =>notification.includes('AnketAdmin') || notification.includes('SuperAdmin')|| notification.includes('AnketKullanici')).length != 0 "
          >
             <formcheckbox 
              :FormDataType="FormDataType.Anketkapalimi"
              :Value="FormData.Anketkapalimi"
              :v="$v.FormData.Anketkapalimi"
              @input="FormData.Anketkapalimi = $event"
            /> 
          </div>
        </div>
        <button class="btn btn-primary" type="submit">
          {{ $t("AnktAnket.AddEdit.Button") }}
        </button>
      </Form>
    </b-modal>
  </Loader>
</template>
